import { useUser } from "@/app/context/UserContext";
import React, { useEffect, useState } from "react";
import { ModeLayout, TypeEnvironment } from "@/app/constants/enums";
import DatacenterUploadIndex from "../Fuente/DatacenterUploadIndex";
import ListDatacenterIndex from "../Fuente/ListDatacenterIndex";
import DatacenterEditNotifications from "../Fuente/DatacenterEditNotifications"
import { useConfig } from "@/app/context/ConfigContext";

 
 
type SearchResultItem = {
  [key: string]: string;
};

const LayoutRight = () => {
  const {modeLayout, userProjectLoaded, userProject} = useUser();
  const { queryParams, baseUrl } = useConfig();
  const [isEditingForm, setIsEditingForm] = useState(true);    
  useEffect(() => {  
    if(userProjectLoaded&&userProject.project.env == TypeEnvironment.Prod){ 
      setIsEditingForm(false);
    } 
  }, []);
    
  return (  
    <aside className="w-full h-full">
      
      {(isEditingForm&&modeLayout==ModeLayout.Edit?
        <>
          <DatacenterUploadIndex />
          <DatacenterEditNotifications />
          
        </>
      :
        <ListDatacenterIndex/>
      )}
  

      
    </aside> 
  );
};

export default LayoutRight;